import React, { Component } from 'react'
import { Redirect, withRouter } from 'react-router-dom'

import { menus, routes } from '_src/config'

import { parseArr, getRoutes, filterMenu } from '_src/utils/tool'

import { getMerchant } from '_src/api/api'

@withRouter
class RedirectException extends Component {

  getPaths (router, key = 'path') {
    let arr = parseArr(router).map(item=>(item[key]))
    arr.push('/login', '/setMerchant')
    return arr
  } 
  render () {
    let allRouterPath = this.getPaths(getRoutes(routes)).map(item=>{
      const pathName = item.split('?')[0]
      return pathName
    })
    let filterRouterPath = this.getPaths(getRoutes(filterMenu(menus)), 'key')
    let unauthorizedPath = routes.filter(item=>{
      return item.unauthorized
    }).map(item=>{
      return item.path
    })
    filterRouterPath = [...filterRouterPath, ...unauthorizedPath]
    const { location: {pathname} } = this.props
    let Node = null
    allRouterPath.push('/')
    filterRouterPath.push('/')

    // 没有路径重定向
    if (!allRouterPath.includes(pathname)) {
      Node = <Redirect to="/404" />
    }
    // 没有权限重定向
    // 暂时去除权限控制
    // if (allRouterPath.includes(pathname)) {
    //   if (!filterRouterPath.includes(pathname)) {
    //     Node = <Redirect to="/403" />
    //   }
    // }
    
    return (
      <div className="app-content">
        { this.props.children}
        {Node}
      </div>
    )
  }
}


@withRouter
class Authorized extends Component {
  // 页面内容显示授权判断
  componentWillReceiveProps = async (nextProps) => {
    const { pathname } = nextProps
    
    // 商品设置判断
    if (pathname !== '/login' && pathname !== 'setMerchant' && this.props.pathname !== nextProps.pathname) {
      const info = await getMerchant()
      const { data: {idCardReverse, idCardObverse }} = info
      if (!idCardObverse&&!idCardReverse) {
        this.props.history.replace('/setMerchant')
      }
    }
  }
  render () {
    const userinfo = localStorage.getItem('access_info')
    const { pathname } = this.props
 
    // const { idCardObverse, idCardReverse } = category
  
    // 去到登录页面
    if (!userinfo&&pathname.indexOf('/login') === -1) {
      return <Redirect to="/login" />
      // 判断必须上传店铺基本信息
    }
    return <div><RedirectException /></div>
  }
}

export default Authorized